import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { type IPageWidget } from './IPageWidget.ts';

export interface IPageWidgetComponentProps
  extends IWidgetComponentProps<IPageWidget> {}

export function PageWidgetComponent(props: IPageWidgetComponentProps) {
  // il componente non sarà visualizzato
  // serve solo come indicazione di Page Break per creare le pagine dello stepper
  return null;
}
